import type {CompRef, PS} from '@wix/document-services-types'
import _ from 'lodash'
import externalCompReadAPI from './externalCompReadAPI'
import externalCompWriteAPI from './externalCompWriteAPI'

export default (ps: PS, compPointer: CompRef, {overrides = undefined, read = true, write = false} = {}) =>
    _.merge({}, write && externalCompWriteAPI(ps, compPointer), read && externalCompReadAPI(ps, compPointer), overrides)
